@if (!imageUrl) {
  <!-- Image Upload UI - shown before image is uploaded -->
  <div class="file-upload-area">
    <input
      #canvasImageInput
      type="file"
      accept="image/*"
      (change)="onCanvasImageSelected($event)"
      style="display: none;"
    >

    <div
      class="upload-dropzone"
      (click)="canvasImageInput.click()"
      [class.uploading]="uploadingCanvasImage"
    >
      @if (uploadingCanvasImage) {
        <motn-spinner></motn-spinner>
        <p>Uploading image...</p>
      } @else {
        <motn-fa-icon icon="fa-regular fa-cloud-arrow-up"></motn-fa-icon>
        <p>Select canvas image</p>
        <span class="hint">Supported formats: PNG, JPG, JPEG, GIF, WEBP</span>
      }
    </div>
  </div>
} @else {
  <!-- Canvas Editor UI - shown after image is uploaded -->
  <div class="canvas-editor-container">
    <div class="controls">
      <span class="hint">
        <i class="fa-solid fa-info-circle"></i> Click on the image to place a tile, drag a tile to move it
      </span>

      <!-- Change Image button on the right -->
      <input
        #changeImageInput
        type="file"
        accept="image/*"
        (change)="onCanvasImageSelected($event)"
        style="display: none;"
      >
      <button
        type="button"
        class="small"
        (click)="changeImageInput.click()"
        [disabled]="uploadingCanvasImage"
      >
        Change Image
      </button>
    </div>

    @if (hasDeletedTiles()) {
      <div class="deleted-tiles-notice">
        <i class="fa-solid fa-triangle-exclamation"></i>
        Some tiles in this canvas no longer exist and have been removed. Save to apply.
      </div>
    }

    <div class="map-wrapper">
      <div id="canvas-editor-map" class="map-container"></div>
      @if (loading()) {
        <div class="loading-skeleton">
          <motn-spinner></motn-spinner>
        </div>
      }
    </div>

    @if (tileSelector(); as selector) {
      @for (state of [selector]; track state) {
        <div class="tile-selector-wrapper"
             [style.left.px]="state.screenPosition.x"
             [style.top.px]="state.screenPosition.y"
             (click)="$event.stopPropagation()">
          <motn-popover-select-tiles
            [tiles]="userTiles"
            [preselectedTileIds]="state.selectedTileIds"
            (clickedOption$)="onTileSelected($event)"
            (clickedOutsideMenu$)="onClickOutsideTileSelector()"
          ></motn-popover-select-tiles>
        </div>
      }
    }

    @if (contextMenu(); as menu) {
      <div class="context-menu-wrapper"
           [style.left.px]="menu.screenPosition.x"
           [style.top.px]="menu.screenPosition.y"
           (click)="$event.stopPropagation()">
        <motn-popover-menu
          [menuTitle]="'Mini Tile Options'"
          [optionGroup]="menu.options"
          (clickedOutsideMenu$)="closeContextMenu()"
          (clickedOption$)="onContextMenuOptionClicked($event)"
        ></motn-popover-menu>
      </div>
    }
  </div>
}
